<template>
    <div id="newStockCheck">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart">
            <!-- <p class="headerT">库存盘点信息</p> -->
            <el-form ref="returnForm" :model="returnForm" :inline="true" label-width="80px" :label-position="labelPosition">
                <el-form-item label="盘点类型">
                    <el-select @change="getPicking" v-model="returnForm.verificationType" placeholder="请选择盘点类型" style="width: 100%;" clearable>
                        <el-option v-for="(item,index) in pickingTypeList" 
                            :label="item.paraName" 
                            :value="item.paraValue"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="盘点仓库" v-if="returnForm.verificationType == 1">
                    <el-select v-model="returnForm.inventoryType" placeholder="请选择盘点仓库" style="width: 100%;" clearable>
                        <el-option v-for="(item,index) in pickingList" 
                            :label="item.paraName" 
                            :value="item.paraCode" 
                            :key="index">
                        </el-option>
                    </el-select>
                    <el-button size="mini" type="primary" class="fr" @click="exportStock()" style="margin-right: 15%;margin-top:10px">导入库存信息</el-button>
                </el-form-item>
                <el-form-item v-if="returnForm.verificationType == 2" label="盘点工程师">
                    <el-select v-model="returnForm.inventoryType" placeholder="请选择盘点工程师" style="width: 100%;" clearable filterable>
                        <el-option v-for="(item,index) in pickingEngineerList" 
                            :label="item.name" 
                            :value="item.id" 
                            :key="index">
                        </el-option>
                    </el-select>
                    <el-button size="mini" type="primary" class="fr" @click="exportStock()" style="margin-right: 15%;margin-top:10px">导入库存信息</el-button>
                </el-form-item>
                <el-form-item label="盘点备注">
                    <el-input clearable v-model.trim="returnForm.memo" type="textarea" placeholder="请输入备注信息" style="margin-bottom: 15px;"></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                :summary-method="getSummaries"
                show-summary
                style="width: 100%">
                <el-table-column
                    align="center"
                    type="index"
                    width="50"
                    label="序号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号">
                </el-table-column> 
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="status"
                    label="盘点状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">待盘点</span>
                        <span v-else>已盘点</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="inventoryQuantity"
                    label="库存数量">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="verificationQuantity"
                    label="盘点数量">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="profitLoss"
                    width="160"
                    label="盘点损益差(单位：%)">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click.stop="addSerial(scope.row,scope.$index)" type="text" size="small">扫描盘点</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50,]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
            <el-dialog title="添加序列号" :visible.sync="dislogSerial" :close-on-click-modal="false" width="800px"  @close="cancelSerial()">
                <el-row>
                    <el-col>
                        <el-form v-if="dislogSerial" ref="materialParams" :model="materialParams">
                            <el-form-item>
                                <el-input  clearable style="width:50%;" @input="queryBySerialNumberData" v-model.trim="materialParams.number" :autofocus="dislogSerial" placeholder="请输入或扫描序列号"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="scanTitle">扫描记录</span>
                        <el-row style="border:1px solid #EBEEF5;border-bottom:none">
                            <el-table
                                :data="codeList"
                                :border="false"
                                height="465"
                                :header-cell-style="{'text-align':'center'}"
                                style="width: 100%;">
                                <el-table-column
                                    align="center"
                                    type="index"
                                    width="50"
                                    label="序号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialCode"
                                    label="物料编号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="modelName"
                                    label="型号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialName"
                                    label="物料名称">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="code"
                                    label="序列号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="操作"
                                    width="50">
                                    <template slot-scope="scope">
                                        <el-button @click.stop="deleteCode(scope.$index, codeList)" type="text" size="small">移除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button type="success" size="small" @click="addSerialComformBtn()">添加</el-button>
                    <el-button size="small" @click="cancelSerial()">取 消</el-button>
                </span>
            </el-dialog>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="DetermineSave()">提交</el-button>
            <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
            {{pageStatus}}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
                    <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        selectParameterInfoBusiness,
        engineerList,
        importInventoryData,
        queryBySerialNumber,
        verificationAdd
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'newStockCheck',
        components: {
        },
        data () {
            return {
                pageStatus:'留在当前页面',
                saveStatus:'YQR',
                dislogMater:false,
                dislogSerial:false,     //添加序列号
                labelPosition:'left',
                returnForm:{
                    verificationType:'', //盘点类型（1:仓库，2:工程师）
                    inventoryType:'',    //仓库类型/工程师id
                    memo:'',
                    status:'YQR'
                },
                pickingTypeList:[],
                pickingList:[],
                pickingEngineerList:[],
                returnData: [],
                curQuantity:0,       //当前物料库存
                curIndex:0,          //当前物料序号
                curMaterialCode:'',  //当前物料编码
                codeList:[],         //已扫描序列号数组
                materialParams:{
                    number:''        //物料序列号字符串
                },
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                }

            }
        },
        created(){
            this.getCheckType()
            this.getEngineerList()
            this.getSelectParameterInfoBusiness()
        },
        methods: {
            //获取盘点类型
            getCheckType(){
                let para = {
                    paraType:'verification_type'
                }
                selectParameterInfoBusiness(para).then(res =>{
                    if (res.data.status==100) { 
                        this.pickingTypeList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error)=>{
                    this.$Message.error(error.message);
                })
            },
            //获取盘点工程师
            getEngineerList(){
                engineerList({}).then(res =>{
                    if (res.data.status==100) { 
                        this.pickingEngineerList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error)=>{
                    this.$Message.error(error.message);
                })
            },
            //导入库存信息
            exportStock(){
                if (this.returnForm.verificationType=="") {
                    this.$message({
                        message: '请选择盘点类型',
                        type: 'warning'
                    });
                    return
                }
                if(this.returnForm.inventoryType==""){
                    if(this.returnForm.verificationType == 1){
                        this.$message({
                            message: '请选择盘点仓库',
                            type: 'warning'
                        });
                    }else{
                        this.$message({
                            message: '请选择盘点工程师',
                            type: 'warning'
                        });
                    }
                    return
                }
                let para = {
                    verificationType:this.returnForm.verificationType,
                    inventoryType:this.returnForm.inventoryType
                }
                importInventoryData(para).then(res =>{
                    if (res.data.status==100) { 
                        this.returnData = res.data.results.list
                        this.returnData.forEach((item,index)=>{
                            item.serialNumberList = [];
                            item.serialList = [];
                        })
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error)=>{
                    this.$Message.error(error.message);
                })
            },
            getPicking(e){
                this.returnForm.inventoryType = ""
                console.log(e)
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.exportStock()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.exportStock()
            },
            deleteCode(index,rows){
                rows.splice(index, 1);
            },
            //添加序列号
            addSerial(row,index){
                this.curIndex = index
                this.curQuantity = row.inventoryQuantity
                this.curMaterialCode = row.materialCode
                this.dislogSerial = true;
                this.codeList = row.serialList;
            },
            //查询序列号物料信息
            queryBySerialNumberData(val){
                if(val.length == 8){
                    let para = {
                        number:this.materialParams.number,
                        affiliationType:(this.returnForm.verificationType == '2') ? 1 : 0,
                        status:1,
                        belonger:(this.returnForm.verificationType == '2') ? this.returnForm.inventoryType : null
                    }
                    queryBySerialNumber(para).then(res => {
                        if (res.data.status==100) {
                            if(res.data.results.length > 0){
                                //判断是否与当前物料编码一致
                                if(this.curMaterialCode != res.data.results[0].materialCode){
                                    this.$message({
                                        message: '当前物料的编码与待扫描的物料编码不一致，请重新输入序列号',
                                        type: "warning"
                                    });
                                    return
                                }
                                let isHave = false
                                if(this.codeList.length > 0){
                                    this.codeList.forEach((item,index)=>{
                                        if(item.code == res.data.results[0].code){
                                            isHave = true
                                        }
                                    })
                                    if(!isHave){
                                        this.codeList.push(res.data.results[0])
                                    }
                                }else{
                                    this.codeList.push(res.data.results[0])
                                }                            
                            }else{
                                this.$message({
                                    message: '您输入的序列号有误，请重新输入',
                                    type: "warning"
                                });
                            }
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            //提交添加序列号
            addSerialComformBtn(){
                if(this.codeList.length == 0){
                    this.$message({
                        message: '您还未开始输入或扫描序列号',
                        type: "warning"
                    });
                }else{
                    this.addEdit();      //添加&修改
                    this.$message({
                        type: 'success',
                        message: '添加成功'
                    });
                }
            },
            //编码相等便修改不相等便添加
            addEdit(){
                let arr = [];
                let index = this.curIndex;
                this.returnData[index].serialNumberList = this.codeList;
                this.codeList.forEach((item,index)=>{
                    arr.push(item.code);
                });
                this.returnData[index].serialNumberList = arr;
                this.returnData[index].verificationQuantity = this.codeList.length;
                this.returnData[index].profitLoss = ((this.returnData[index].verificationQuantity / this.returnData[index].inventoryQuantity) * 100).toFixed(2);
                
                this.cancelSerial();
            },
            //取消/关闭添加序列号弹出框
            cancelSerial(){
                this.dislogSerial = false;
                this.codeList = [];
                this.materialParams.number = "";
            },
            //金额转化函数
            toThousands2(num) {
                num = num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                    num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //获取盘点仓库列表
            getSelectParameterInfoBusiness(){
                let para={
                    paraType: 'warehouse_type'
                }
                selectParameterInfoBusiness(para).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingList = res.data.results.list          
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/stockCheck'
                })
            },
            refresh() {
                this.returnForm = {
                    verificationType:'', //盘点类型（1:仓库，2:工程师）
                    inventoryType:'',    //仓库类型/工程师id
                    memo:'',
                    status:'YQR'
                },
                this.returnData = []
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index < 5) {
                        return;
                    }
                    if(index > 6){
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            //已提交
            DetermineSave(){
                this.saveStatus = 'YQR';
                if (this.returnForm.verificationType=="") {
                    this.$message({
                        message: '请选择盘点类型',
                        type: 'warning'
                    });
                    return
                }
                if(this.returnForm.inventoryType==""){
                    if(this.returnForm.verificationType == 1){
                        this.$message({
                            message: '请选择盘点仓库',
                            type: 'warning'
                        });
                    }else{
                        this.$message({
                            message: '请选择盘点工程师',
                            type: 'warning'
                        });
                    }
                    return
                }
                if(this.returnData.length == 0){
                    this.$message({
                        message: '请导入库存信息，再提交',
                        type: 'warning'
                    });
                    return
                }else{
                    let para={
                        inventoryType: this.returnForm.inventoryType, //仓库类型/工程师id
                        verificationStatus:2,  //盘点状态
                        verificationType:this.returnForm.verificationType, //盘点类型（1:仓库，2:工程师）
                        memo:this.returnForm.memo,
                        status:this.saveStatus,
                        detailsList: this.returnData,
                    }
                    console.log(JSON.stringify(para))
                    verificationAdd(para).then(res => {
                        if (res.data.status==100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            this.refresh();
                            if (this.pageStatus == '离开当前页面') {
                                this.tabRemove(this.$route.path)
                                this.$router.replace({
                                    path:'/stockCheck'
                                })
                            }
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                    
                }
                
            },
            closeSave(){
                this.pageStatus = "离开当前页面"
            },
            goOnSave(){
                this.pageStatus = "留在当前页面"
            
            },
            //取消新建
            cancelOrder(){
                this.tabRemove(this.$route.path)
                this.$router.replace({
                    path:'/stockCheck'
                })
            },
            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
              ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            }
        },
        computed: {
        },
        watch: {
          
        },
    
    }
</script>

<style type="text/css" lang="scss" scoped>
    #newStockCheck{
        .totalDiv{
            height: auto;
            overflow: hidden;
            text-align: right;
            font-size: 16px;
            background-color: #fff;
            border-bottom: 1px solid #e5e9f2;
            padding: 10px;
        }
        .headerSpan{
            margin-right:20px
        }
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .searthPart{
            .el-input{width: 100%;}
        }
        .el-input-number--small{
            width:100% !important
        }
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .listPart{
            border:1px solid #c6c6c6;
            margin:-8px 15px 10px 0;
            border-radius: 5px;
            text-align: center;
            position: relative;
            z-index: 0;
            cursor: pointer;
            padding: 5px 10px;
        }
        li.active{
            background-color:#1abc9c;
            color:#fff;
            border-color: #1abc9c;
        }
        .activeBtn{
            background-color: #1abc9c;
            color:#fff;
        }
        .eventLi{
            border-left:1px solid #1abc9c;
            padding-bottom: 20px;
            .childSpan{
                padding-left: 20px;
                margin-bottom: 5px;
            }
            .childSpan:first-child{
                padding-left: 0px;
                margin:-5px 0 0 -5px;
            }
            .childSpan span.orderId{
                color: #3399FF;
            }
            .createTime i{
                display: block;
                width: 10px;
                height: 10px;
                border-radius: 20px;
                background-color: #1abc9c;margin: 0px 15px 0px -5px;
            }
        }
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        .el-step__icon.is-text{border-color: #1abc9c;}
        .scanTitle{
            display:block;
            margin:10px
        }
    }
  
</style>



// WEBPACK FOOTER //
// newStockCheck.vue?7f85ca78